import React, { useState, useEffect } from "react";
import { Card, CardHeader, Icon } from "@ui5/webcomponents-react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Tooltip, Legend } from "recharts";
import httpRequest from "../httpRequest";

const ScanAccuracyRateCard = () => {
  const [latestData, setLatestData] = useState([]);
  const [allTimeData, setAllTimeData] = useState([]);
  const [numScans, setNumScans] = useState(50); // State to track number of scans to display

  useEffect(() => {
    fetchPerformanceData();
  }, [numScans]); // Refetch data when numScans changes

  const fetchPerformanceData = async () => {
    try {
      const resp = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-all-performance-data`);
      const performanceData = resp.data;
      // Limit data to specified number of scans
      setLatestData(performanceData.slice(0, numScans));
      setAllTimeData(performanceData); // Assuming you fetch all-time data separately
    } catch (error) {
      console.error("Error fetching performance data:", error);
    }
  };

  // Function to handle header click
  const handleHeaderClick = () => {
    // Update numScans based on current value
    if (numScans === 10) {
      setNumScans(50);
    } else if (numScans === 50) {
      setNumScans(100);
    } else {
      setNumScans(10);
    }
  };

  // Custom tooltip formatter to round values to two decimal places
  const customTooltipFormatter = (value, name) => {
    return [`${name}: ${value.toFixed(2)}`];
  };

  return (
    <Card>
      <CardHeader
        interactive // Make the CardHeader clickable
        onClick={handleHeaderClick}
        subtitleText="Click to toggle scans"
        status={`Last ${numScans} Scans`}
        titleText="Scan Performance Rate"
      />
      <Box display="flex" justifyContent="center" alignItems="center">
        <RadarChart outerRadius={140} width={300} height={375} data={latestData}>
          <PolarGrid />
          <PolarAngleAxis dataKey="name" />
          <PolarRadiusAxis />
          <Radar name="Average Score" dataKey="average_score" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
          <Radar name="Parsing Time (s)" dataKey="parsing_time" stroke="#82ca9d" fill="#82ca9d" fillOpacity={0.6} />
          {/* Add more Radar components for additional metrics */}
          <Tooltip formatter={customTooltipFormatter} />
          <Legend />
        </RadarChart>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
        <TableContainer>
          <Table style={{ fontFamily: 'SapFiori72' }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell style={{  fontFamily: 'SapFiori72' }}>Average Score</TableCell>
                <TableCell style={{  fontFamily: 'SapFiori72' }}>Parsing Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell style={{  fontFamily: 'SapFiori72' }}>All Time</TableCell>
                <TableCell>{calculateAverageScore(allTimeData).toFixed(2)}</TableCell>
                <TableCell>{calculateAverageParsingTime(allTimeData).toFixed(2)}s</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Card>
  );
};

// Function to calculate average score
const calculateAverageScore = (data) => {
  const totalScore = data.reduce((acc, curr) => acc + (curr.average_score || 0), 0);
  return totalScore / data.length;
};

// Function to calculate average parsing time
const calculateAverageParsingTime = (data) => {
  const totalParsingTime = data.reduce((acc, curr) => acc + (curr.parsing_time || 0), 0);
  return totalParsingTime / data.length;
};

export default ScanAccuracyRateCard;
